import Delta from '@/App/tiles/TargetAccumulator/MarketData/Delta.tsx';
import Forward from '@/App/tiles/TargetAccumulator/MarketData/Forward.tsx';
import PremiumGappedCcy from '@/App/tiles/TargetAccumulator/MarketData/PremiumGappedCcy.tsx';
import PremiumRateStoCcyMid from '@/App/tiles/TargetAccumulator/MarketData/PremiumRateStoCcyMid.tsx';
import SwapPoints from '@/App/tiles/TargetAccumulator/MarketData/SwapPoints.tsx';
import Vega from '@/App/tiles/TargetAccumulator/MarketData/Vega.tsx';
import Volatility from '@/App/tiles/TargetAccumulator/MarketData/Volatility.tsx';
import { useUserContext } from '@/context/UserContext.tsx';

const MarketData = () => {
  const {
    currentUser: {
      featureToggles: { premiumGappedMid },
    },
  } = useUserContext();

  return (
    <>
      <Volatility />
      <Forward />
      <SwapPoints />
      <Delta />
      <Vega />
      <PremiumRateStoCcyMid />
      {premiumGappedMid && <PremiumGappedCcy />}
    </>
  );
};

export default MarketData;
